import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {getFirestore} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCiDqmDHilfZB_vFljAJjNJmXOkga3qTqU",
  authDomain: "invoice-app-7f5d7.firebaseapp.com",
  projectId: "invoice-app-7f5d7",
  storageBucket: "invoice-app-7f5d7.firebasestorage.app",
  messagingSenderId: "215729504205",
  appId: "1:215729504205:web:39117ca4de51736c270e84",
  measurementId: "G-L0REF4KZPQ"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const db = getFirestore(app);
